import { EstadoCivil, Genero } from 'src/app/pages/pessoas/models/colaborador.model';

export interface OpcaoEnum<T = string> {
  label: string;
  value: T;
}

// BUG-012 (regressivo-pos-migracao 2026-07-29): unificacao das opcoes canonicas.
// Antes existiam 2 copias locais (aba-hierarquia.component.ts + este arquivo)
// com labels ligeiramente diferentes (acentuacao). Consolidado aqui como fonte
// unica — labels com acentuacao completa PT-BR (padrao mais recente ja usado
// em aba-hierarquia). Consumers: perfil-edit-modal, aba-hierarquia (form embutido
// do BUG-009) e colaborador-form-modal SHARED (fix BUG-015).
// NOTA: modal-criar-usuario-portal foi consumer historico (fix BUG-012) mas foi
// removido em AUDIT-06 (2026-07-29) por ser dead code — SHARED absorveu o papel.
export const ESTADO_CIVIL_OPTIONS: OpcaoEnum<EstadoCivil>[] = [
  { label: 'Solteiro(a)',   value: 'SOLTEIRO' },
  { label: 'Casado(a)',     value: 'CASADO' },
  { label: 'Divorciado(a)', value: 'DIVORCIADO' },
  { label: 'Viúvo(a)',      value: 'VIUVO' },
  { label: 'União estável', value: 'UNIAO_ESTAVEL' },
  { label: 'Outro',         value: 'OUTRO' }
];

export const GENERO_OPTIONS: OpcaoEnum<Genero>[] = [
  { label: 'Masculino',            value: 'MASCULINO' },
  { label: 'Feminino',             value: 'FEMININO' },
  { label: 'Outro',                value: 'OUTRO' },
  { label: 'Prefiro não declarar', value: 'INDIFERENTE' }
];

export const ESTADO_CIVIL_LABEL_MAP: Record<string, EstadoCivil> = {
  'solteiro':       'SOLTEIRO',
  'solteiro(a)':    'SOLTEIRO',
  'casado':         'CASADO',
  'casado(a)':      'CASADO',
  'divorciado':     'DIVORCIADO',
  'divorciado(a)':  'DIVORCIADO',
  'viuvo':          'VIUVO',
  'viuvo(a)':       'VIUVO',
  'viúvo':          'VIUVO',
  'viúvo(a)':       'VIUVO',
  'uniao estavel':  'UNIAO_ESTAVEL',
  'união estável':  'UNIAO_ESTAVEL',
  'outro':          'OUTRO'
};

export const GENERO_LABEL_MAP: Record<string, Genero> = {
  'masculino':             'MASCULINO',
  'feminino':              'FEMININO',
  'outro':                 'OUTRO',
  'prefiro nao declarar':  'INDIFERENTE',
  'prefiro não declarar':  'INDIFERENTE',
  'indiferente':           'INDIFERENTE'  // Compatibilidade com valor legado
};

export const PERFIL_LABEL_MAP: Record<string, string> = {
  admin:          'Gestor',
  administrador:  'Gestor',
  gestor:         'Gestor',
  colaborador:    'Colaborador',
  rh:             'RH'
};
